<div *ngIf="service.showLoader || service.showFiltersLoader">
  <img class="loader-image" src="assets/img/svg/logo-hartmann.svg" />
  <div class="loader"></div>
  <div id="page_overlay"></div>
</div>
